/**
 * Created by René Simon <rene.simon@dr-huchler-und-partner.de> on 25.08.17.
 * Copyright © Dr. Huchler und Partner 2017
 */

import _ from 'lodash';

export default _;
